import React from 'react'
import {Button, Link} from 'startlibs/lib/components'
import {ExpiredPageComponent, ContentBox} from './ExpiredShare'

export class ExpiredDeletionLink extends React.PureComponent {

  render() {
    return (
      <ExpiredPageComponent>
        <div className="navbar">
          <Link to="/" className="logo">Horos Cloud</Link>
        </div>
        <ContentBox>
          <img src="/public/expired-icon.png" alt="Expired" />
          <h2>This link has expired.</h2>
          <p>The deletion link you are accessing has expired and you are no longer able to proceed. Deletion links expire after one hour for security reasons.</p>
          <p>In case you still need to delete your data, please access your Horos Cloud account and request for the data deletion one more time.</p>
          <Button.Link highlight skipTo="/signIn">Access Horos Cloud</Button.Link>
        </ContentBox>
      </ExpiredPageComponent>
    )
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/public/ExpiredDeletionLink.jsx